import {setFetchingForView, setMetaProp, setView, setCurrent, upsert} from '../../../helpers'

export default {
  setFetchingForView,
  setMetaProp,
  setView,
  setCurrent,
  upsert
}



// WEBPACK FOOTER //
// ./src/store/modules/tenants/mutations.js